const useViewActions = ({
  setSelectedView,
  onChangeView,
  saveView,
  createView,
  getFilters,
  setHasViewChanges,
  selectedView,
}) => {
  const handleChangeView = view => {
    setSelectedView(view)
    onChangeView(view)
  }

  const handleSaveView = name => {
    saveView({ name, filters: getFilters() })
  }

  const handleCreateView = () => {
    createView({ filters: getFilters() })
  }

  const handleDiscardViewChanges = () => {
    setHasViewChanges(false)
    onChangeView(selectedView)
  }

  return {
    handleChangeView,
    handleSaveView,
    handleCreateView,
    handleDiscardViewChanges,
  }
}

export default useViewActions
